export default {
  index: {
    title: 'My Account',
    tab: {
      baseTitle: 'Account Information',
      resetTitle: 'Change Password',
      profileTitle: 'Basic Information',
    },
  },
  base: {
    submitText: 'Save',
    successText: 'Saved Successfully',
  },
  reset: {
    submitText: 'Submit',
    successText: 'Edit Successfully',
    verifycode: 'Verification failed, please try again',
    describe:
      'This password will be applied to all products under Mobvista of Mobvista Technology.',
  },
  form: {
    name: {
      label: 'Username：',
      title: 'User Name',
    },
    contact: {
      title: 'Contact Name',
    },
    cell: {
      title: 'Phone Number',
      placeholder: 'Please enter your phone number',
    },
    organization: {
      title: 'Company',
      placeholder: 'Please enter your company name',
    },
    country: {
      title: 'Country or Region',
      placeholder: 'Please select country or region',
    },
    mail: {
      label: 'Email：',
      placeHolder: 'Please enter your email address',
      required: 'Email Address cannot be empty.',
      formatVeryfy: 'Please enter a valid email address',
      title: 'Contact Email',
    },
    password: {
      label: 'Current Password：',
      placeHolder: 'Please enter your current password',
      required: 'The current password cannot be empty',
      validatePassNewOld:
        'New passwords cannot be the same as the old password',
      validatePassSame: 'Please make sure your passwords match',
      validatePass:
        '8-20 characters, combination of numbers and uppercase letters. (e.g., Psw1234567).',
      validatePassEmpty: 'The password cannot be empty',
    },
    newPassword: {
      label: 'New Password：',
      placeHolder: 'Please enter your new password',
      required: 'The new password cannot be empty',
    },
    confirmPassword: {
      label: 'Confirm Password：',
      placeHolder: 'Please reenter your password',
      required: 'Confirmation password cannot be empty',
    },
    ccEmail: {
      title: 'CC Email Address',
      tip: 'Allow adding multiple emails to receive message notifications from Playturbo',
      validate: 'Email Address Error',
      placeholder: 'Please input the CC email address',
    },
    currency: {
      title: 'Settlement Currency',
    },
  },
  plan: {
    expirationReminder: 'Expiration Reminder',
    expirationReminderTips:
      'Your subscription is about to expire, please renew timely.',
    insufficientQuota: 'Insufficient Balance',
    insufficientQuotaTips:
      'Subscription quota is exhausted, authorization will be automatically canceled in 30 days. Please renew timely to continue enjoying the service.',
    message: {
      confirm: 'Got it',
    },
  },
}
